var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteTextIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 5.87258 5.37258 0.5 12 0.5H36C42.6274 0.5 48 5.87258 48 12.5V36.5C48 43.1274 42.6274 48.5 36 48.5H12C5.37258 48.5 0 43.1274 0 36.5V12.5Z",
    fill: "#FF627D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.5C18.38 14.5 16.25 16.63 16.25 19.25C16.25 21.82 18.26 23.9 20.88 23.99C20.96 23.98 21.04 23.98 21.1 23.99C21.12 23.99 21.13 23.99 21.15 23.99C21.16 23.99 21.16 23.99 21.17 23.99C23.73 23.9 25.74 21.82 25.75 19.25C25.75 16.63 23.62 14.5 21 14.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.08 26.65C23.29 24.79 18.74 24.79 15.93 26.65C14.66 27.5 13.96 28.65 13.96 29.88C13.96 31.11 14.66 32.25 15.92 33.09C17.32 34.03 19.16 34.5 21 34.5C22.84 34.5 24.68 34.03 26.08 33.09C27.34 32.24 28.04 31.1 28.04 29.86C28.03 28.63 27.34 27.49 26.08 26.65Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9899 19.84C32.1499 21.78 30.7699 23.48 28.8599 23.71C28.8499 23.71 28.8499 23.71 28.8399 23.71H28.8099C28.7499 23.71 28.6899 23.71 28.6399 23.73C27.6699 23.78 26.7799 23.47 26.1099 22.9C27.1399 21.98 27.7299 20.6 27.6099 19.1C27.5399 18.29 27.2599 17.55 26.8399 16.92C27.2199 16.73 27.6599 16.61 28.1099 16.57C30.0699 16.4 31.8199 17.86 31.9899 19.84Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9902 29.09C33.9102 30.06 33.2902 30.9 32.2502 31.47C31.2502 32.02 29.9902 32.28 28.7402 32.25C29.4602 31.6 29.8802 30.79 29.9602 29.93C30.0602 28.69 29.4702 27.5 28.2902 26.55C27.6202 26.02 26.8402 25.6 25.9902 25.29C28.2002 24.65 30.9802 25.08 32.6902 26.46C33.6102 27.2 34.0802 28.13 33.9902 29.09Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteTextIcon);
export default __webpack_public_path__ + "static/media/note-text-icon.8a9be22c1ec9df8423d17de082f6cc38.svg";
export { ForwardRef as ReactComponent };